import React, { useEffect, useState } from "react";
import { Form, Button, Table } from "react-bootstrap";

const BuscadorDocumentos = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [resultados, setResultados] = useState([]);
  const [documentos, setDocumentos] = useState([]);

  useEffect(() => {
    getUsuarios();
    getDocumentos();
  }, []);

  const handleBuscar = (e) => {
    e.preventDefault();
    const term = textoBusqueda.toLowerCase();
    const usuariosFiltrados = usuarios.filter(
      (usuario) =>
        usuario.Nombre.toLowerCase().includes(term) ||
        usuario.Apellidos.toLowerCase().includes(term)
    );

    const documentosFiltrados = documentos.filter((doc) =>
      usuariosFiltrados.some((usuario) => usuario.UsuarioID === doc.usuario_id)
    );

    const resultadosConUsuarios = documentosFiltrados.map((doc) => {
      const usuario = usuarios.find((user) => user.UsuarioID === doc.usuario_id);
      return {
        ...doc,
        usuario,
      };
    });

    setResultados(resultadosConUsuarios);
  };

  const getUsuarios = async () => {
    try {
      const response = await fetch("https://oficinavirtual-solponiente.com/api/usuarios", {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        setUsuarios(data);
      } else {
        console.error("Error al obtener usuarios");
      }
    } catch (error) {
      console.error("Error al hacer la solicitud de usuarios:", error);
    }
  };

  const getDocumentos = async () => {
    try {
      const response = await fetch("https://oficinavirtual-solponiente.com/api/documentos", {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        setDocumentos(data);
      } else {
        console.error("Error al obtener documentos");
      }
    } catch (error) {
      console.error("Error al hacer la solicitud de documentos:", error);
    }
  };

  const handleDownload = (doc) => {
    const binaryData = atob(doc.Documento); // Decodificar el base64 a datos binarios
    const blob = new Blob([new Uint8Array(binaryData.split("").map((char) => char.charCodeAt(0)))]);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = doc.NombreDocumento || "documento.pdf"; // Nombre del archivo
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <Form onSubmit={handleBuscar}>
        <Form.Group controlId="textoBusqueda">
          <Form.Label>Buscar Documentos por Usuario</Form.Label>
          <Form.Control
            type="text"
            placeholder="Nombre o apellido del usuario"
            value={textoBusqueda}
            onChange={(e) => setTextoBusqueda(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" type="submit" className="mt-3">
          Buscar
        </Button>
      </Form>

      {resultados.length > 0 && (
        <div className="mt-4">
          <h3>Resultados de Documentos</h3>
          <Table striped bordered hover className="table-responsive">
            <thead>
              <tr>
                <th>Nombre del Documento</th>
                <th>Usuario</th>
                <th>Fecha de Subida</th>
                <th>Firmado por Usuario</th>
                <th>Firmado por Admin</th>
                <th>Descargar</th>
              </tr>
            </thead>
            <tbody>
              {resultados.map((doc) => (
                <tr key={doc.DocumentoID}>
                  <td>{doc.NombreDocumento}</td>
                  <td>
                    {doc.usuario.Nombre} {doc.usuario.Apellidos}
                  </td>
                  <td>{doc.FechaSubida}</td>
                  <td>{doc.FirmadoUser ? "Sí" : "No"}</td>
                  <td>{doc.FirmadoAdmin ? "Sí" : "No"}</td>
                  <td>
                    <Button
                      variant="secondary"
                      size="sm"
                      onClick={() => handleDownload(doc)}
                    >
                      Descargar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default BuscadorDocumentos;
